import styled from 'styled-components'
import { desktop, mobile } from '../../styles/media'
import { StyledButton } from '../button/Button'
import { StyledBreadcrumb } from './Breadcrumb'
import H2 from '../general/H2'
import H1 from './H1'
import { StyledActionButton } from '../button/ActionButton'
import ThickHeading from '../text/ThickHeading'
import H3 from '../general/H3'

const Header = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 1rem;

	> :last-child:not(${H1}):not(${StyledActionButton}):not(${ThickHeading}):not(${H3}) {
		display: flex;
		gap: 0.5rem;
	}

	${H2} {
		margin-bottom: 0;
	}

	${desktop`
		${props => !props.fullWidth && `
			max-width: 800px;
		`}
	`}

	${mobile`
		align-items: flex-start;

		${StyledButton} {
			font-size: 0.9rem;
			padding: 0.5rem 1rem;
		}

		${StyledBreadcrumb} + & {
			margin-top: -0.5rem;
		}
	`}
`

export default Header
